import React from "react"
import PropTypes from "prop-types"
import Radium, { keyframes } from "higher-order-components/configured-radium/"

const LoaderIcon = ({ styleName = "dark", scale = 1, style }) => {
  const color = styleName === "dark" ? "#fff" : "#101010"
  const dim = 38
  const viewBox = `0 0 ${dim} ${dim}`

  return (
    <div
      style={{
        position: "relative",
        transform: `scale(${scale})`,
        height: dim + "px",
        margin: "0 auto",
        width: dim + "px",
        ...style
      }}>
      <svg
        style={{ position: "absolute", top: 0, right: 0 }}
        width={dim}
        height={dim}
        viewBox={viewBox}
        stroke={color}>
        <g fill="none" fillRule="evenodd">
          <g transform="translate(1 1)" strokeWidth="2">
            <circle strokeOpacity=".5" cx="18" cy="18" r="18" />
          </g>
        </g>
      </svg>
      <svg
        style={[{ position: "absolute", top: 0, right: 0 }, styles.rotate]}
        width={dim}
        height={dim}
        viewBox={viewBox}
        fill="none"
        stroke={color}>
        <g transform="translate(1 1)" strokeWidth="2">
          <path d="M36 18c0-9.94-8.06-18-18-18" />
        </g>
      </svg>
    </div>
  )
}

LoaderIcon.propTypes = {
  styleName: PropTypes.oneOf(["dark", "light"]),
  scale: PropTypes.number
}

const rotate = keyframes({
  to: {
    transform: "rotate(360deg)"
  }
})

const styles = {
  rotate: {
    animation: "x ease 1s infinite",
    animationName: rotate
  }
}

export default Radium(LoaderIcon)



// WEBPACK FOOTER //
// ./src/components/icons/loader-icon.jsx